import React, { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { getTimeGap } from "../../containers/Tracking/utils";
import { smallLogo } from "../../assets";
import sprite from "../../assets/icons.svg";
import spriteNative from "../../containers/Tracking/assets/nativeIcons/icons.svg";
import { NoData } from "../../containers/Shared";
import { useDispatch } from "react-redux";
import { setGlobalDockAlign } from "../../reduxStore/features";
import { getLocalizedString } from "../../shared/translation";
import { QIButton } from "../QIButton";

export const QIDragAndDropDetails = ({
  setDetails,
  setPopup,
  deviceData = {},
  removeLayerOnClose,
  selectedVehiclePlate,
  removeRowSelection,
  setDockAlign,
  deviceId,
  realTimedata = [],
  dockAlign,
  setDeviceId,
  setShowTrack,
  headerItems = ["collapse", "split-down", "split-left", "split-right", "pop-out", "cross"],
  headerName,
  headerDetails,
  listDetails,
  setSelectedRowId,
  currentTab,
  setmaximizeMinimize,
  maximizeMinimize,
  customContent = false,
  type = "Devices",
  children,
  liveDetailsBlockView,
  setLiveDetailsBlockView,
  setCurrentTab,
  setSelectedVehiclePlate,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (dockAlign !== "split-down") {
      if (maximizeMinimize) {
        dispatch(setGlobalDockAlign("split-down"));
        setDockAlign("split-down");
      }
    }
  }, [maximizeMinimize, dockAlign, setGlobalDockAlign, dispatch, setDockAlign]);

  const closeDeviceDetails = () => {
    removeLayerOnClose && removeLayerOnClose();
    setDetails(false);
    removeRowSelection();
    setDeviceId && setDeviceId(null);
    setSelectedVehiclePlate && setSelectedVehiclePlate(null);
    setCurrentTab && setCurrentTab("Map");
    //setShowTrack(false);
  };

  const { status, description } = getTimeGap(
    realTimedata?.[type === "Vehicles" ? selectedVehiclePlate : deviceId]?.source_time ||
      deviceData?.source_time?.v ||
      deviceData?.report_time
  );

  //Header Items
  const renderHeaderItems = headerItems.map((item) => {
    return (
      item !== dockAlign && (
        <React.Fragment key={item}>
          <div
            onClick={() => {
              item === "collapse" && setmaximizeMinimize((prev) => !prev);
              item === "cross" && closeDeviceDetails();
              item === "pop-out" && setPopup();
              if (item !== "collapse") {
                item !== "cross" && dispatch(setGlobalDockAlign(item));
                setDockAlign(item);
                if (item !== "split-down") {
                  setmaximizeMinimize(false);
                }
              }
            }}
            className="details-block_actions_item"
          >
            <svg
              className={`icon ${item} ${
                item === "collapse" && (maximizeMinimize ? "rotate-90" : "rotate-270")
              }`}
            >
              <use
                href={`${item === "cross" || item === "collapse" ? sprite : spriteNative}#${item}`}
              ></use>
            </svg>
          </div>
        </React.Fragment>
      )
    );
  });
  //Header Items End

  return (
    <>
      <aside className="details-block_actions">{renderHeaderItems}</aside>

      <section
        className={`${
          (currentTab === "Map" || currentTab === "LiveTrack") &&
          Object?.keys(deviceData).length === 0 &&
          deviceData.constructor === Object &&
          liveDetailsBlockView !== "TrackPoints"
            ? "no-data"
            : `details-block_section_${currentTab === "Map" ? liveDetailsBlockView : currentTab}`
        }  `}
      >
        {!customContent && (
          <>
            {Object.keys(deviceData).length !== 0 && deviceData.constructor === Object ? (
              <>
                {headerDetails && (
                  <aside className="details-block_summary">
                    {currentTab === "Map" && liveDetailsBlockView === "Details" && (
                      <div className="mb-4">
                        <QIButton
                          className="primary w-full sm"
                          onClick={() => setLiveDetailsBlockView("TrackPoints")}
                          icon={{
                            src: {
                              /* <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M15 19l-7-7 7-7"
                                />
                              </svg> */
                            },
                            wrapperClass: "mr-2",
                          }}
                        >
                          {getLocalizedString("back_to_trackpoints", "Back to Trackpoints")}
                        </QIButton>
                      </div>
                    )}
                    <div className="details-block_summary_item-info">
                      <div className="item-photo">
                        <img src={smallLogo} alt="logo" />
                        <span className={`status ${status}`} title={description}></span>
                      </div>
                      <ul className="details-block_summary_list">{headerDetails}</ul>
                    </div>
                  </aside>
                )}
                {listDetails}
              </>
            ) : (
              <NoData />
            )}
          </>
        )}

        {customContent && <>{children}</>}
      </section>
    </>
  );
};
